import React, { useEffect, useState, useRef } from "react";
import {
    Row,
    Col,
    Card,
    Button,
    Container,
    CardBody,
    CardImg,
    CardText,
    Badge,
    CardTitle,
    Modal, ModalHeader, ModalBody, ModalFooter
} from "reactstrap";
import { AvForm, AvField } from 'availity-reactstrap-validation';
import Select from "react-select";
import FileUpload from "components/Common/file-upload/file-upload.component";
import Language from "Enums/Language"
import SelectOptions from "components/SelectOptions"
import CategoriesService from "services/Admin/CategoriesService"
import BuildingService from "services/Admin/BuildingService"
import CompoundService from "services/Admin/CompoundService"
import { SuccessCreated, SuccessOk } from "configs/statusCode";
import { toast } from 'react-toastify';
import { adminPrefix } from "configs/routePrefix";
import { floors, bathrooms, bedrooms, years, payment_methods } from "Enums/fixedData"
import SuccessModal from "components/SucessModal"
import CancelModal from "components/CancelModal"
import { useSelector } from "react-redux";

// const languages = ["en", "ar", "zh", "ru"]
const languages = ["en"]
const initialData = {
    selectedCatogory: null,
    en: "",
    ar: "",
    ru: "",
    zh: "",
    descrip_en: "",
    descrip_ar: "",
    descrip_zh: "",
    descrip_ru: "",
    floor_num: "",
    selectedCompound: null,
    title_before_numbers: '',
    to: "",
    from: ""
}
const BuildingForm = (props) => {
    const buildingService = new BuildingService()
    const [formData, setFormData] = useState(initialData)
    const [mediaIds, setMediaIds] = useState([])
    const [catogoryOptions, setCatogoryOptions] = useState([])
    const [CompoundOpttions, setCompoundOpttions] = useState([])
    const [modal, setModal] = useState(false)
    const [successModal, setSuccessModal] = useState(false)
    const [loading, setLoading] = useState(false)
    const [uploadState, setUploadState] = useState(false)
    const filterData = useSelector(state=> state.adminFilter)
    const compound_id = filterData.compound_id || localStorage.getItem('compound_id')
    const addBuilding = filterData?.addBuilding || localStorage.getItem('addBuilding')

    useEffect(() => {
        if (props.id) {
            buildingService.find(props.id).then(response => {
                if (response && response.status === SuccessOk) {
                    const newSelected = response.data.categories.map(item => {
                        return {
                            label: item ?.name ?.en,
                            value: item.id
                        }
                    })

                    setFormData({
                        ...formData,
                        ar: response.data.name.ar,
                        en: response.data.name.en,
                        ru: response.data.name.ru,
                        zh: response.data.name.zh,
                        descrip_ar: response.data.description.ar,
                        descrip_en: response.data.description.en,
                        descrip_ru: response.data.description.ru,
                        descrip_zh: response.data.description.zh,
                        floor_num: response.data.floors_num,
                        selectedCatogory: [...newSelected],
                        selectedCompound: response.data?.compound?.id
                    })

                    setMediaIds(response.data.images)


                }
            })

        }
    }, [])

    const handleFieldChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const updatedAttachment = (attachments, type) => {
        setMediaIds([...mediaIds, ...attachments])
    };

    // FILE UPLOADmediaIds
    const deleteAttachment = (Items, type) => {
        let updatedMedia = mediaIds.filter(item => item.id != Items[0].id)
        setMediaIds(updatedMedia)

    };

    const sumbmitFormHandler = () => {
        if (!formData.selectedCatogory) {
            toast.error(" Please Select Building Category")
            return
        }
        else if (!formData.floor_num) {
            toast.error(" Please Select Floor Number")
            return
        }
        setLoading(true)
        let data = {
            description: {},
            floors_num: formData.floor_num,
            compound_id: compound_id,
            categories_ids: [...formData.selectedCatogory.map(item => item.value)],
            images_ids:mediaIds.length > 0 ? mediaIds.map(item => item.id) :[]
        }
        
        if(addBuilding == "addBuilding"){
            data['name'] = { en: formData.en }
        }
        if(addBuilding == "addBuildings"){
            data['name'] = { en: formData.title_before_numbers }
            data['title_number_from'] = formData.from
            data['title_number_to'] = formData.to
        }

        languages.forEach(language => {
            if (formData[`descrip_${language}`].length) {
                data.description[language] = formData[`descrip_${language}`]
            }
        })
         if (props.id) {
            buildingService.update(props.id, data).then(response => {
                if (response && response.status === SuccessOk) {
                    // toast.success(response.data.success)
                    // props.history.push(`${adminPrefix}/Admin-developer/building`);
                    setLoading(false)
                    setSuccessModal(true)

                } else {
                    setLoading(false)
                }
            })
        } else {
            buildingService.create(data).then(response => {
                if (response && response.status === SuccessCreated) {
                    setLoading(false)
                    setSuccessModal(true)

                } else {
                    setLoading(false)
                }
            })
        }
    }
    return (
        <>
            <AvForm className="form-horizontal" onValidSubmit={(e, v) => sumbmitFormHandler(e, v)}>
                <Card >
                    <CardBody>
                        {/* <Row className="mb-1">
                            <h5>Name</h5>
                        </Row> */}
                        <Row>
                            {addBuilding == "addBuilding" && <Col md={6} className="mb-3">
                                <AvField
                                    name={'en'}
                                    label={`Building Name`}
                                    bsSize="lg"
                                    value={formData?.en}
                                    onChange={(e => handleFieldChange(e))}
                                    required={true}
                                    errorMessage="This field is required"
                                    placeholder={'Building Name'}
                                />
                            </Col>}
                            {addBuilding == "addBuildings" &&<> 
                                <Col md={6} className="mb-3">
                                    <AvField
                                        name={'title_before_numbers'}
                                        label={`Title Before Numbers (Optional)`}
                                        bsSize="lg"
                                        value={formData?.title_before_numbers}
                                        onChange={(e => handleFieldChange(e))}
                                        required={false}
                                        placeholder={'Title Before Numbers'}
                                        // validate={{
                                        //     pattern: {
                                        //         value: /^(?!.*-$)[a-zA-Z0-9 %!@#$%^&*()_+=~`{}|:;"'<>,.?/\\[\]-]*$/,
                                        //         errorMessage: `this format is invalid`
                                        //     }
                                        // }}
                                    />
                                </Col>
                                <Col md={3} >
                                <AvField
                                    name={"from"}
                                    label={"From"}
                                    bsSize="lg"
                                    value={formData.from}
                                    onChange={(e => handleFieldChange(e))}
                                    required
                                    placeholder={'From'}
                                    type="number"
                                    min={"0"}
                                />
                            </Col>
                            <Col md={3}>
                                <AvField
                                    name={"to"}
                                    label={"To"}
                                    bsSize="lg"
                                    value={formData.to}
                                    onChange={(e => handleFieldChange(e))}
                                    required
                                    placeholder={'To'}
                                    type="number"
                                    min={`${parseInt(formData.from)+1}`}

                                />
                            </Col>
                            </>}
                            <Col md={6}  >
                                <AvField
                                    name={"floor_num"}
                                    label={"Building Floors"}
                                    bsSize="lg"
                                    value={formData.floor_num}
                                    onChange={(e => handleFieldChange(e))}
                                    required
                                    errorMessage="This field is required"
                                    placeholder={'Floor Number'}
                                    type="number"
                                    min={"1"}
                                    max={"200"}

                                />
                            </Col>
                            <Col md={6}>
                                <SelectOptions
                                    label='Building Category'
                                    placeholder='Select'
                                    options={catogoryOptions}
                                    handleSelectChange={(data) => {
                                        setFormData({ ...formData, selectedCatogory: data });
                                    }}
                                    selectedOption={formData.selectedCatogory}
                                    Service={CategoriesService}
                                    setOptions={(options) => {
                                        setCatogoryOptions(options)
                                    }}
                                    isMulti={true}
                                />
                            </Col>
                            {/* <Row className="mb-1">
                                <h5>Description</h5>
                            </Row> */}
                            {Language.LIST.map((lan, index) => {
                                return (
                                    <Col md={12} key={index} >
                                        <AvField
                                            className="mb-3"
                                            name={lan.descrip_name}
                                            label={`Description (${lan.name})`}
                                            bsSize="lg"
                                            value={formData[`${lan.descrip_name}`]}
                                            onChange={(e => handleFieldChange(e))}
                                            required={false}
                                            type="textarea"
                                            placeholder={lan.name === "en" ? 'English' : lan.name === "ar" ? "العربية" : lan.name === "zh" ? "中文" : "Русский"}
                                        />
                                    </Col>
                                )
                            })}
                        </Row>
                    </CardBody>
                </Card >
                <Card >
                    <CardBody>
                        <Row>
                            <Col md={12}>
                                <FileUpload
                                    accept='.jpg,.png,.jpeg,.JPG,.PNG,.JPEG'
                                    label='Building Images'
                                    setUpload={()=> {}}
                                    attachmentType='media_id'
                                    attachmentData={mediaIds}
                                    updatedAttachment={updatedAttachment}
                                    deleteAttachment={deleteAttachment}
                                    multiple
                                    setUploadState={setUploadState}
                                />
                            </Col>
                        </Row>
                    </CardBody>
                </Card >
                <Row className="mb-4">
                    <Col md={6} className="d-flex">
                        <button
                            type="button"
                            onClick={() => setModal(true)}
                            className="btn btnHeight btn-light"
                        >
                            Cancel
                         </button>
                    </Col>
                    <Col md={6} className=" d-flex flex-row-reverse">
                        <button
                            type="submit"
                            disabled={uploadState ? true : loading ? true : false}
                            className="btn btn-success btnHeight"
                        >
                            Submit
                         </button>
                    </Col>

                </Row>
                <CancelModal modal={modal}
                    setModal={setModal}
                    goBackHandler={() => props.history.push(`${adminPrefix}/Admin-developer/building`)}
                />
            </AvForm >
            <SuccessModal
                modal={successModal}
                message={props.id ? "Edited Building Successfully" : "New Building Added Successfully"}
                onClick={() => {
                    props.history.push(`${adminPrefix}/Admin-developer/building`)
                }}
                title={props.id ? "Edit Building " : "Add New Building"}
            />
        </>
    )
}

export default BuildingForm
